// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e97e630d","724":"383c3ae4"}[chunkId] + ".chunk.js";
};